import {
  AccountThirdPartyServiceOperationCancelledEvent,
  AccountThirdPartyServiceOperationFailEvent,
  AccountThirdPartyServiceOperationStartEvent,
  AccountThirdPartyServiceOperationSuccessEvent,
  GeneralButtonActionEvent,
  Screen,
  ThirdPartyService,
  ThirdPartyServiceCategory,
  ThirdPartyServiceOperation,
  trackEvent,
  UIElementID,
  UIInteractionType,
} from '@otter-ai/telemetry';

export const trackMicrosoftMain = {
  connectionStart: () => {
    trackEvent(
      AccountThirdPartyServiceOperationStartEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.microsoft,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectionEstablished: () => {
    trackEvent(
      AccountThirdPartyServiceOperationSuccessEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.microsoft,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectionCanceled: () => {
    trackEvent(
      AccountThirdPartyServiceOperationCancelledEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.microsoft,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectionFailed: () => {
    trackEvent(
      AccountThirdPartyServiceOperationFailEvent({
        Screen: Screen.apps,
        ThirdPartyService: ThirdPartyService.microsoft,
        ThirdPartyServiceCategory: ThirdPartyServiceCategory.calendar,
        ThirdPartyServiceOperation: ThirdPartyServiceOperation.connect,
      }),
    );
  },

  connectMicrosoft: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsMicrosoftConnect,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },

  disconnectMicrosoft: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsMicrosoftDisconnect,
        UIInteractionType: UIInteractionType.secondaryActivate,
      }),
    );
  },

  handleMicrosoftContact: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsMicrosoftContact,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },

  handleMicrosoftVideoActivate: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsMicrosoftVideoActivate,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },
} as const;

export const trackMicrosoft = {
  main: trackMicrosoftMain,
} as const;
